import { Button } from '../../Button'
import { ButtonProps } from '../../Button/Types'
import { Plus } from 'blaze-ui/icons'

export const AddReviewerButton = ({ onPress }: Pick<ButtonProps, 'onPress'>) => (
  <div>
    <Button onPress={onPress} frontIcon={Plus} size="md" variant="tertiary">
      Reviewer
    </Button>
  </div>
)
